<template>
  <div class="upload-set-wrap">
    <header>
      数据管理
      <Button v-if="hasData" class="operape-btn" @click="downloadModule">下载模板</Button>
      <Button v-if="hasData" class="operape-btn" @click="hasData = false">上传数据</Button>
    </header>
    <div class="content">
      <div class="operate-wrap" v-if="!hasData">
        <Upload class="upload-btn" :on-success="handleSuccess" :action="uploadUrl" :data="param">
          <img src="/static/images/upload.png" alt />
          <p>点击此处上传Excel数据文件</p>
        </Upload>
        <Button class="download-btn" @click="downloadModule">下载文件模板</Button>
      </div>
      <div class="datalist" v-else>
        <Table class="data-table" :columns="columns" :data="datalist" :height="tableHeight"></Table>
        <Page
          class="page-wrap"
          :current="curPage"
          :page-size="pageSize"
          :show-total="true"
          :total="total"
          @on-change="changePage"
        />
      </div>
    </div>
    <!-- <Button
      type="primary"
      class="inline_block"
      :disabled="isPlan"
      :loading="waiting"
      v-on:click="planData()"
    >上传</Button>-->
  </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";
import appConfig from "../../config/config.js";
import { frontPages } from "../service/frontPages.js";

export default {
  data: function() {
    return {
      uploadUrl: appConfig.BASE_URL + api.update,
      curPage: 1,
      pageSize: 20,
      total: 0,
      param: {
        userId: ""
      },
      hasData: false,
      tableHeight: document.documentElement.clientHeight - 112,
      columns: [
        { title: "名称", key: "name", minWidth: 180 },
        { title: "城市", key: "city", minWidth: 60 },
        { title: "经度（高德）", key: "lng", minWidth: 80 },
        { title: "纬度（高德）", key: "lat", minWidth: 80 },
        {
          title: "访问频次（次/月）",
          key: "frequency",
          align: "center",
          minWidth: 60
        },
        {
          title: "停留时长（分）",
          key: "staytime",
          align: "center",
          minWidth: 60
        }
      ],
      allData: [],
      datalist: []
    };
  },
  computed: {
    userId() {
      return sessionStorage.getItem("userId");
    }
  },
  methods: {
    async initData() {
      let res = await getData.get(api.getUserPoint, { userId: this.userId });
      if (res.data && res.data.status) {
        if (res.data.data.length > 0) {
          this.hasData = true;
          this.total = res.data.data.length;
          this.allData = res.data.data;
          this.changePage(this.curPage);
        } else {
          this.hasData = false;
        }
      } else {
        this.$Message.info(res.data.msg);
      }
    },
    changePage(v) {
      this.datalist = frontPages({
        all: this.allData,
        curPage: v,
        pageSize: this.pageSize
      });
    },
    downloadModule() {
      window.location.href = appConfig.BASE_URL + "/demotemp/排班数据模板.xlsx";
    },
    handleSuccess(res, file) {
      if (res.status) {
        //上传数据成功
        this.$Message.info(res.msg);
        this.key = res.key;
        this.isPlan = false;
        // 重新获取数据
        this.initData();
      } else {
        this.$Message.info(res.msg);
      }
    }
  },
  mounted() {
    //初始化地图
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      this.$router.push({ path: "/demo-login" });
    }
    this.param.userId = userId;
    this.initData();
  }
};
</script>

<style lang="sass">
  @import "../assets/stylesheets/upload_demo"
</style>



// WEBPACK FOOTER //
// src/components/DemoUpload.vue